import React, { useState, useEffect } from 'react';
import './index.css';

import Loader from './components/Loader';
import CustomCursor from './components/CustomCursor';
import ScrollProgress from './components/ScrollProgress';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import WhyUs from './components/WhyUs';
import Occasions from './components/Occasions';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import CTA from './components/CTA';
import Footer from './components/Footer';
import MobileCTA from './components/MobileCTA';

export default function App() {
  const [loaderHidden, setLoaderHidden] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaderHidden(true), 1800);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      {/* SEO meta is best handled via react-helmet or index.html – see public/index.html */}

      <Loader hidden={loaderHidden} />
      <CustomCursor />
      <ScrollProgress />

      <div style={{ opacity: loaderHidden ? 1 : 0, transition: 'opacity 0.5s ease 0.2s' }}>
        <Navbar />

        <main>
          <Hero />
          <About />
          <WhyUs />
          <Occasions />
          <Gallery />
          <Reviews />
          <CTA />
        </main>

        <Footer />
        <MobileCTA />
      </div>
    </>
  );
}
